import { useCallback } from 'react';
import * as actions from '@actions';
import { useDispatch } from 'react-redux';
import useAppointmentDetails from './appointments/useAppointmentDetails';

export function useMedicationsLoader(clinician_user_guid: string, appointment_id: number) {
  const dispatch = useDispatch();

  const { detailsCurrentAppointment } = useAppointmentDetails(appointment_id);

  return useCallback(async () => {
    if (!detailsCurrentAppointment?.meds) return { medications: [] };

    const medsAndDrugs = await Promise.all(
      detailsCurrentAppointment.meds.map(async (med) => ({
        ...med,
        value: med.vtm_name,
        drugs: await dispatch(actions.getDrugForms(clinician_user_guid, appointment_id, String(med.vtm_id)))
      }))
    );

    const meds = medsAndDrugs
      ?.map(({ drugs: { vmp }, ...med }) => ({
        ...med,
        vmp_options: vmp,
        current_vmp: vmp?.find((opt) => String(opt.vmp_id) === String(med.vmp_id))
      }))
      .map((meds) => ({ ...meds, vmp_name: meds.vmp_name || meds.current_vmp?.vmp_name }));

    if (meds.some(({ current_vmp }) => !current_vmp)) return { medications: [] };

    return { medications: meds };
  }, [detailsCurrentAppointment, dispatch, clinician_user_guid, appointment_id]);
}

export type Medication = Awaited<ReturnType<Awaited<ReturnType<typeof useMedicationsLoader>>>>['medications'][0];

export default useMedicationsLoader;
